export default __webpack_public_path__ + "static/media/illustration.3760df78.svg";